export default "__VITE_ASSET__DpLvKahR__"